import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import {
  fetchCatidleclose,
  pushCatIdleclose,
  delCatidleclose
} from "../../api/portal";
import { pushLoader } from "../../actions/main";
import Button from "components/CustomButtons/Button.jsx";
import IconAdd from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";
import { withRouter } from "react-router-dom";

class Idleclosecat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      openAdd: false,
      category: [],
      idletime: 0,
      name: "",
      description: "",
      timeidle: 0,
      distance: 0
    };
  }

  UNSAFE_componentWillMount() {
    fetchCatidleclose()
      .then(responsex => {
        if (responsex != null) {
          this.setState({ datatable: responsex.data.results });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  handleRowSelect = e => {
    // console.log(e);
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  handleSave = () => {
    this.props.pushLoader(true);
    pushCatIdleclose(this.state)
      .then(responsex => {
        this.props.pushLoader(false);
        this.handleClose("openAdd", false);
        fetchCatidleclose()
          .then(responsex => {
            if (responsex != null) {
              this.setState({ datatable: responsex.data.results });
            }
          })
          .catch(error => {
            //this.props.pushToken(error);
            this.props.history.push("/pages/login#logout");
          });
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleChangeName = e => {
    this.setState({ name: e.target.value });
  };

  handleChangeDescription = e => {
    this.setState({ description: e.target.value });
  };

  handleChangeIdletime = e => {
    this.setState({ timeidle: e.target.value });
  };
  handleChangeDistance = e => {
    this.setState({ distance: e.target.value });
  };

  handleDelete = deletedRows => {
    const deletedIndexes = Object.keys(deletedRows.lookup);
    deletedIndexes.map(e => {
      const a = this.state.datatable[e];
      delCatidleclose(a.id)
        .then(response => {
          fetchCatidleclose()
            .then(responsex => {
              if (responsex != null) {
                this.setState({ datatable: responsex.data.results });
              }
            })
            .catch(error => {
              //this.props.pushToken(error);
              this.props.history.push("/pages/login#logout");
            });
        })
        .catch(error => {
          //this.props.pushToken(error);
          this.props.history.push("/pages/login#logout");
        });
    });
  };

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "name",
        label: "Category Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "description",
        label: "Description",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "timeidle",
        label: "Idle Time in Hour",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "distance",
        label: "Distance in Meter",
        options: {
          filter: false,
          display: true
        }
      }
    ];

    const options = {
      filter: false,
      search: true,
      selectableRows: true,
      print: false,
      download: false,
      responsive: "scroll",
      viewColumns: false,
      onRowsDelete: this.handleDelete,
      onRowClick: e => {
        this.handleRowSelect(e);
      }
    };
    return (
      <div>
        <Button
          onClick={() => this.handleClose("openAdd", true)}
          color="success"
          round
        >
          <IconAdd /> Add Category
        </Button>
        <MUIDataTable
          data={this.state.datatable}
          columns={columns}
          options={options}
        />
        <Dialog
          maxWidth={"md"}
          open={this.state.openAdd}
          onClose={() => this.handleClose("openAdd", false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Add Category</DialogTitle>
          <DialogContent>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="Category Name"
                  id="name"
                  inputProps={{
                    value: this.state.name,
                    onChange: this.handleChangeName
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="Description"
                  id="description"
                  inputProps={{
                    value: this.state.description,
                    onChange: this.handleChangeDescription
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="Idle Time (Hours)"
                  id="timeidle"
                  inputProps={{
                    value: this.state.timeidle,
                    onChange: this.handleChangeIdletime,
                    type: "number"
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="Distance (Meter)"
                  id="distance"
                  inputProps={{
                    value: this.state.distance,
                    onChange: this.handleChangeDistance,
                    type: "number"
                  }}
                  formControlProps={{
                    fullWidth: true
                  }}
                />
              </GridItem>
            </GridContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleSave} color="success" round>
              Save
            </Button>
            <Button
              onClick={() => this.handleClose("openAdd", false)}
              color="danger"
              round
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Idleclosecat.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushZonaTarget: PropTypes.string,
  pushPoiTarget: PropTypes.array,
  pushLoader: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushCatIdleclose, pushLoader }
)(Idleclosecat));
